import type {FunctionComponent} from 'react';
import {useTranslation} from '@app/hooks/use-translation';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {Image} from '@app/components/Image';
import {useLocation} from '@app/hooks/use-location';
import {LandingButtonLink} from '@app/components/landing-btn-link';
import type {LocalImageConfig} from '@app/hooks/use-local-image';
import {useLocalImage} from '@app/hooks/use-local-image';
import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';

const IMAGE_CONFIG: LocalImageConfig = {
	default: '2a27333e43c509d0dca0db45a0211d1f.jpg',
	pt: '1700bfd25fdecedbd340563e4fd98fa4.jpg',
	'pt-br': '1700bfd25fdecedbd340563e4fd98fa4.jpg',
	de: 'c4caab6e01accb4bd364568e3f1eef98.jpg',
	fr: '8fd2691193342b3df4ccfc6ba1cdd387.jpg',
};

export const PodcastsSection: FunctionComponent = () => {
	const {t} = useTranslation();
	const {getDeezerUrl} = useLocation();
	const src = useLocalImage(IMAGE_CONFIG);
	return (
		<LandingIllustrationSection
			description={
				<>
					<LandingHeading as="h2">
						{t(
							'featureslandingpage_title_podcastsworthlisteningto_standalone-web',
							{ns: 'features'},
						)}
					</LandingHeading>
					<LandingParagraph>
						{t(
							'featureslandingpage_text_podcastsworthlisteningto_standalone-web',
							{ns: 'features'},
						)}
					</LandingParagraph>
				</>
			}
			image={
				<Image
					aspectRatio="2048/530"
					quality={70}
					src={src}
					alt={t('metatag_text_widepodcastcatalog_standalone-web', {
						ns: 'common',
					})}
				/>
			}
			cta={
				<LandingButtonLink
					tracking={{eventaction: 'discover', eventlabel: 'podcast'}}
					href={getDeezerUrl('/podcasts')}
				>
					{t('generic_action_discovermore_standalone-web', {ns: 'common'})}
				</LandingButtonLink>
			}
		/>
	);
};
